<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { computed } from 'vue';
import propertyImage from 'dashboard/assets/real-estate/sales-overview-welcome.png';

const props = defineProps({
  row: { type: Object, default: null },
});

const emit = defineEmits(['openStatus']);

const selected = computed(
  () =>
    props.row || {
      id: 'VDA-0198-002',
      title: 'Casa 02 · Residencial Jardim',
      address: 'Rua das Palmeiras, 250 · São Paulo - SP',
      amount: 8750,
      beneficiary: 'Carla Almeida',
      expected: '10/05/2025',
      status: 'Atrasado',
    }
);
const money = value =>
  new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  }).format(Number(value || 8750));
</script>

<template>
  <section class="flex min-h-full flex-col text-[#172968]">
    <header
      class="flex items-center justify-between border-b border-slate-100 pb-4"
    >
      <h2 class="text-[14px] font-bold">Visualização rápida</h2>
      <div class="flex items-center gap-3">
        <span
          class="inline-flex items-center gap-1 rounded-lg bg-emerald-50 px-2 py-1 text-[10px] font-bold text-emerald-700"
          ><span class="i-lucide-shield-check size-3" />Auditável</span
        ><button
          type="button"
          class="i-lucide-x size-4 text-[#172968]"
          aria-label="Fechar painel"
        />
      </div>
    </header>
    <div class="pt-4">
      <div class="flex items-center gap-2">
        <h3 class="text-[16px] font-bold">{{ selected.id }}</h3>
        <span
          class="rounded-md bg-red-50 px-2 py-1 text-[10px] font-bold text-red-600"
          >{{ selected.status || 'Atrasado' }}</span
        >
      </div>
      <div class="mt-4 flex gap-3">
        <img
          :src="propertyImage"
          alt=""
          class="size-[76px] rounded-xl object-cover"
        />
        <div class="min-w-0">
          <strong class="block text-[12px]">{{ selected.title }}</strong>
          <p class="mt-1 text-[11px] leading-relaxed text-[#45558c]">
            {{ selected.address }}
          </p>
        </div>
      </div>
    </div>
    <dl
      class="mt-5 divide-y divide-slate-100 border-y border-slate-100 text-[11px]"
    >
      <div class="flex items-center justify-between gap-3 py-3">
        <dt class="flex items-center gap-2 text-[#45558c]">
          <span class="i-lucide-circle-dot size-3.5" />Valor da parcela
        </dt>
        <dd class="text-[15px] font-bold text-red-600">
          {{ money(selected.amount) }}
        </dd>
      </div>
      <div
        v-for="item in [
          ['Origem', 'Recebimento', 'i-lucide-calendar-days'],
          [
            'Vencimento',
            selected.expected || '10/05/2025',
            'i-lucide-calendar-clock',
          ],
          ['Centro de custo', 'Vendas - SP', 'i-lucide-building-2'],
          ['Categoria', 'Sinal', 'i-lucide-tag'],
          ['Forma de pagamento', 'Transferência bancária', 'i-lucide-landmark'],
        ]"
        :key="item[0]"
        class="flex items-center justify-between gap-3 py-3"
      >
        <dt class="flex items-center gap-2 text-[#45558c]">
          <span :class="item[2]" class="size-3.5" />{{ item[0] }}
        </dt>
        <dd class="max-w-[160px] text-right font-semibold">{{ item[1] }}</dd>
      </div>
      <div class="flex items-center justify-between gap-3 py-3">
        <dt class="flex items-center gap-2 text-[#45558c]">
          <span class="i-lucide-user-round size-3.5" />Favorecido
        </dt>
        <dd class="flex items-center gap-2 font-semibold">
          <span
            class="grid size-7 place-items-center rounded-full bg-[#4922bb] text-[9px] font-bold text-white"
            >CA</span
          >{{ selected.beneficiary || 'Carla Almeida' }}
        </dd>
      </div>
    </dl>
    <section class="mt-4 rounded-xl border border-slate-200 p-3">
      <h3 class="text-[12px] font-bold">Comprovante</h3>
      <div class="mt-3 flex items-center gap-2">
        <span
          class="grid size-9 place-items-center rounded-lg bg-violet-50 text-[#4b22b8]"
          ><span class="i-lucide-file-text size-4"
        /></span>
        <div class="min-w-0 flex-1">
          <strong class="block truncate text-[10px]"
            >comprovante_198_002.pdf</strong
          ><span class="text-[9px] text-[#45558c]"
            >Enviado em 09/05/2025 às 09:00</span
          >
        </div>
        <span
          class="rounded-md bg-emerald-50 px-1.5 py-1 text-[9px] font-bold text-emerald-700"
          >Aprovado</span
        >
      </div>
    </section>
    <section class="mt-3 rounded-xl border border-slate-200 p-3">
      <h3 class="text-[12px] font-bold">Histórico de lembretes</h3>
      <div
        v-for="message in [
          'Lembrete de vencimento enviado por e-mail',
          'Lembrete de vencimento enviado por WhatsApp',
        ]"
        :key="message"
        class="mt-3 flex gap-2"
      >
        <span
          class="grid size-6 place-items-center rounded-full bg-violet-50 text-[#4b22b8]"
          ><span class="i-lucide-bell size-3"
        /></span>
        <p class="text-[10px] leading-relaxed text-[#45558c]">
          <strong class="block text-[#172968]">09/05/2025 às 09:00</strong
          >{{ message }}
        </p>
      </div>
    </section>
    <section class="mt-3">
      <h3 class="text-[12px] font-bold">Auditoria e integridade</h3>
      <div
        v-for="event in [
          'Lançamento criado por Carla Almeida',
          'Data de vencimento definida para 10/05/2025',
          'Valor definido para R$ 8.750,00',
        ]"
        :key="event"
        class="mt-3 flex gap-2"
      >
        <span
          class="grid size-6 place-items-center rounded-full border border-slate-200 text-[#4b22b8]"
          ><span class="i-lucide-pencil size-3"
        /></span>
        <p class="text-[10px] leading-relaxed text-[#45558c]">
          {{ event }}<span class="block">06/05/2025 às 11:20</span>
        </p>
      </div>
    </section>
    <button
      type="button"
      class="mt-5 flex min-h-11 w-full items-center justify-center gap-3 rounded-xl bg-gradient-to-r from-[#4320bb] to-[#721ad8] px-4 text-[13px] font-bold text-white shadow-lg shadow-violet-300/50"
      @click="emit('openStatus', selected)"
    >
      <span class="i-lucide-circle-check-big size-5" />Conciliar lançamento<span
        class="rounded-lg bg-white/15 px-2 py-1 text-[10px]"
        >+50 pontos</span
      >
    </button>
    <div
      class="mt-4 flex gap-2 rounded-xl bg-teal-50 p-3 text-[10px] leading-relaxed text-[#45558c]"
    >
      <span class="i-lucide-shield-check mt-0.5 size-4 text-teal-600" />
      <p>
        <strong class="block text-[#172968]"
          >Experiência segura e auditável</strong
        >Todas as ações são registradas. Transparência que gera confiança.
      </p>
    </div>
  </section>
</template>
